import { useTranslation } from 'react-i18next';

export function SkipLink() {
  const { t } = useTranslation('common');
  return (
    <a href="#main" className="skip-link">
      {t('skip')}
    </a>
  );
}
